import Pusher from 'pusher-js';

// Pusher.logToConsole = true;
const pusher = new Pusher('29a5ef17b2f4d64aed32', {
    cluster: 'ap2',
    forceTLS: true,
});
export default pusher;